import {
  enableProdMode,
  ErrorHandler,
  APP_INITIALIZER,
  importProvidersFrom,
  provideZoneChangeDetection
} from "@angular/core";
import * as Sentry from "@sentry/angular";

import { createTranslateLoader } from "./app/app.module";
import { environment } from "./environments/environment";
import { LoaderService } from "./app/services/loader.service";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from "@angular/common/http";
import { LoaderInterceptor } from "./app/interceptors/loader.interceptor";
import { IdentificationInterceptor } from "./app/interceptors/identification.interceptor";
import { Router, RouterModule } from "@angular/router";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { AppRoutingModule } from "./app/app-routing.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { provideAnimations } from "@angular/platform-browser/animations";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDialogModule } from "@angular/material/dialog";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { MatCardModule } from "@angular/material/card";
import { MatRadioModule } from "@angular/material/radio";
import { MatButtonModule } from "@angular/material/button";
import { AppComponent } from "./app/app.component";

// eslint-disable-next-line @typescript-eslint/no-require-imports
const { version } = require("../package.json");

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://a640c96a6ef5773d362505b32e1fc6d9@o249058.ingest.us.sentry.io/4509400388141056",
  sendDefaultPii: true,
  environment: environment.production ? "production" : "development",
  release: "orderportal@" + version,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      RouterModule,
      MatTooltipModule,
      FontAwesomeModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatProgressSpinnerModule,
      MatDialogModule,
      FormsModule,
      NgbModule,
      ToastrModule.forRoot(),
      NgSelectModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      MatCardModule,
      MatRadioModule,
      MatButtonModule,
    ),
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdentificationInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
